
export interface IActionResult {
}
